//libs
import React, {Component} from 'react';
import {connect} from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
//components
import SearchForm from '../UI_Elements/Forms/SearchForm';
import SearchResultsTable from '../UI_Elements/Search/SearchResultsTable';
import PageWithSidebar from '../Layouts/PageWithSidebar';
import CreateCarForm from '../UI_Elements/Forms/CreateCarForm';
import PopUp from '../UI_Elements/Forms/PopUp';
//config and heloers
import {wheelsAdminShift,searchWheels} from '../../actions/wheels';
import {isAdmin} from '../../helpers';

moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');

class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchString: '',
            editWheelSet:0,
            editWheelSetData:[]
        }
        this.shiftWheels = this.shiftWheels.bind(this)
    }

    componentWillReceiveProps(props) {
        if (props.refresh.fetch['SearchTable'] && props.refresh.fetch['SearchTable'] === true) {
            this.props.searchWheels(this.state.searchString);
        }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit(e) {
        e.preventDefault()
        this.props.searchWheels(this.state.searchString);
    }

    shiftWheels() {
        const {wheelsOnCar} = this.props.searchData;
        if (wheelsOnCar.length > 0) {
            let wheelId = wheelsOnCar[0].id;
            if (wheelId) {
                if (this.state.searchString.length===0){
                    this.setState({
                        searchString:wheelsOnCar[0].regNo
                    })

                }
                this.props.wheelsAdminShift(wheelId);
            }
        }
    }

    getWheelSetData(id){

        let allwheels = [this.props.searchData.wheelsOnCar,
            this.props.searchData.wheelsOnStation,
            this.props.searchData.wheelsOnDelivery,
            this.props.searchData.wheelsAtWheelDistributor
        ];

        let x = null;
        let y = null;

        for (y in allwheels){
            for(x in allwheels[y]){
                if (parseInt(allwheels[y][x].id,10)===parseInt(id,10)){
                    let wheel = allwheels[y][x];
                    wheel.wheelType = wheel.wheeltype.id;
                    wheel.offRentDate = moment(wheel.offRentDateTime).toDate();
                    wheel.lastOnRentDate = moment(wheel.lastOnRentDate).toDate();
                    return wheel;
                }
            }
        }


    }

    editWheelSet(e){
        let id = e.target.getAttribute("value");
        this.setState({
            editWheelSet:id,
            editWheelSetData:this.getWheelSetData(id)
        });
        e.preventDefault();
    }

    editWheelSetCancel(e){
        this.setState({
            editWheelSet:0,
            editWheelSetData:null
        });
    }

    render() {

        const {editWheelSet,editWheelSetData} = this.state;
        const {wheelsOnCar,wheelsOnStation,wheelsOnDelivery,wheelsAtWheelDistributor} = this.props.searchData;
		const {loading} = this.props;
		let forceShift="";

        console.log(editWheelSetData, 'editWheelSetData in Search index.js');

		if (isAdmin()){
             forceShift = (
                <input
                    type={"button"}
                    onClick={this.shiftWheels}
                    className='btn yellow send-orders'
                    name='shift-wheels'
                    disabled={wheelsOnCar.length > 0 ? false : true}
                    value={"Skifta däck"}
                />
            )
        }


        return (
            <PageWithSidebar page={"orders searchPage"} location={this.props.location}>

                <h1>Sök hjulset</h1>

                <SearchForm
                    value={this.state.searchString}
                    onChange={(e)=>this.handleChange(e)}
                    onClick={(e)=>this.handleSubmit(e)}
                    name='searchString'
                    className='search-wheelset'
                    placeholder='Regnr eller Serienr'
                />

                {wheelsOnCar && wheelsOnCar.length>0  &&
                    <div>
                        <SearchResultsTable
                            title={"Wheels on Car"}
                            data={wheelsOnCar}
                            loading={loading}
                            editWheelSet={(e)=>this.editWheelSet(e)}
                        >
                        {forceShift}
                        </SearchResultsTable>
                    </div>
                }

                {wheelsOnStation && wheelsOnStation.length>0 &&
                    <div>
                        <SearchResultsTable
                            title={"Wheels on Station"}
                            data={wheelsOnStation}
                            loading={loading}
                            editWheelSet={(e)=>this.editWheelSet(e)}
                        />
                    </div>
                }

                {wheelsOnDelivery && wheelsOnDelivery.length>0 &&
                    <div>
                        <SearchResultsTable
                            title={"Wheels on Delivery"}
                            data={wheelsOnDelivery}
                            loading={loading}
                            editWheelSet={(e)=>this.editWheelSet(e)}
                        />
                    </div>
                }

                {wheelsAtWheelDistributor && wheelsAtWheelDistributor.length>0 &&
                    <div>
                        <SearchResultsTable
                            title={"Wheels at Wheel Distributor"}
                            data={wheelsAtWheelDistributor}
                            loading={loading}
                            editWheelSet={(e)=>this.editWheelSet(e)}
                        />
                    </div>
                }


                {editWheelSet>0 &&
                    <PopUp
                        title={null}
                        showButtons={false}
                        onCancel={(e)=>this.editWheelSetCancel(e)}
                        onClose={(e)=>this.editWheelSetCancel(e)}>
                        <CreateCarForm
                            car={editWheelSetData}
                        />
                    </PopUp>
                }

            </PageWithSidebar>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        searchData: state.wheels.searchData,
        loading: state.wheels.loading,
        refresh: state.refresh
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchWheels: (searchQuery) => dispatch(searchWheels(searchQuery)),
        wheelsAdminShift: (wheelIds) => dispatch(wheelsAdminShift(wheelIds)),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Search);


// WEBPACK FOOTER //
// ./src/components/Search/index.js